import { useQuery } from "@tanstack/react-query";
import { SiteNotice } from "@jkast90/kast-common/ui";
import { getBanner, queryKeys } from "../api/salvagers";

/** The admin-set site message, shown to everyone under the header. */
export default function Banner() {
  const { data } = useQuery({ queryKey: queryKeys.banner, queryFn: getBanner, staleTime: 5 * 60_000 });
  return <SiteNotice notice={data} />;
}
